// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"layout_loadingContainer__1VzXv","loadingAnimation":"layout_loadingAnimation__3bu0p"};